import React from 'react';

import PropTypes from 'prop-types';

import {
    localize,
} from 'wanderu-i18n';

import c2cConfig from '../../../../config/c2c.locale';
import HeroHeader from '../../HeroHeader/HeroHeader';

const propTypes = {
    locationData: PropTypes.shape({
        arrival: PropTypes.object.isRequired,
        departure: PropTypes.object.isRequired,
    }).isRequired,
    departDate: PropTypes.string,
};
const defaultProps = {
    departDate: '',
};

function CityToCityHeader(props) {
    const {
        t,
        locationData,
        departDate,
    } = props;
    const {
        placeId: destinationPlaceId,
        formattedAddress: formattedDestinationAddress,
    } = locationData.arrival;
    const {
        placeId: originPlaceId,
        formattedAddress: formattedOriginAddress,
    } = locationData.departure;

    return (
        <HeroHeader
            title={t('widgetTitleCheapest')}
            widgetProps={{
                departDate,
                defaultDestinationPlaceId: destinationPlaceId,
                defaultOriginPlaceId: originPlaceId,
                defaultDestinationInput: formattedDestinationAddress,
                defaultOriginInput: formattedOriginAddress,
            }}
        />
    );
}

CityToCityHeader.propTypes = propTypes;
CityToCityHeader.defaultProps = defaultProps;

export { CityToCityHeader };
export default localize(CityToCityHeader, ['t'], c2cConfig.namespace);
